import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { ItestState } from "./tests.types";

const selectDomain = (state: any) => state.testReducer;

export const test = createDraftSafeSelector(
  selectDomain,
  (test: ItestState) => test.test
);

export const singletest = createDraftSafeSelector(
  selectDomain,
  (test: ItestState) => test.singleTest
);

export const testsuccessMessage = createDraftSafeSelector(
  selectDomain,
  (test: ItestState) => test.testSuccessMesssage
);

export const testError = createDraftSafeSelector(
  selectDomain,
  (test: ItestState) => test.testError
);

export const testActivityInProcess = createDraftSafeSelector(
  selectDomain,
  (test: ItestState) => test.istestActivityInProcess
);


export const totalPages = createDraftSafeSelector(
  selectDomain,
  (test: ItestState) => test.totalPages
);


export const totalRecords = createDraftSafeSelector(
  selectDomain,
  (test: ItestState) => test.totalRecords
);
